<template>
  <div class="img-and-content-container">
    <h2 class="title-row">{{ $dt(eleConfig, 'title') }}</h2>
    <div class="img-and-content-inner">
      <div class="text-box">
        <div class="percent-row">
          <div class="percent-item">
            <div class="number">
              <div>50%</div>
            </div>
            <div class="text">{{ $t('平时成绩') }}</div>
          </div>
          <dol-icon type="PlusOutlined" class="percent-icon" />
          <div class="percent-item">
            <div class="number">
              <div>50%</div>
              <div class="bg"></div>
            </div>
            <div class="text">{{ $t('外部考试') }}</div>
          </div>
        </div>
        <a-row :gutter="[32,32]">
          <a-col :span="12">
            <div class="subject-item">
              <div class="subject-name">{{ $t('科目1') }}</div>
              <div class="subject-remark">{{ $t('科目说明1') }}</div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="subject-item">
              <div class="subject-name">{{ $t('科目2') }}</div>
              <div class="subject-remark">{{ $t('科目说明2') }}</div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="subject-item">
              <div class="subject-name">{{ $t('科目3') }}</div>
              <div class="subject-remark">{{ $t('科目说明3') }}</div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="subject-item">
              <div class="subject-name">{{ $t('科目4') }}</div>
              <div class="subject-remark">{{ $t('科目说明4') }}</div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div class="data-box">
        <template v-for="(item, index) in eleConfig.dataList">
          <dol-icon v-if="index>0" type="CaretDownOutlined" class="data-icon" />
          <div class="data-item">{{ $dt(item, 'title') }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import componentMixin from './componentMixin';

export default {
  name: "specialD",
  mixins: [componentMixin],
  computed: {
    imgSrc() {
      const image = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return image ? this.$Dolphin.path.publicPath + image.filePath : '';
    },
  }
};
</script>

<style scoped lang="scss">
.img-and-content-container {
  width: 100%;
  padding: 96px 0;
  background-color: white;

  .title-row {
    font-size: 32px;
    font-weight: 600;
    line-height: 45px;
    color: #003C82;
    width: 1280px;
    margin: 0 auto 54px;
  }

  .img-and-content-inner {
    width: 1280px;
    margin: 0 auto;
    display: flex;

    .text-box {
      width: 600px;
      margin-right: 118px;

      // 50%+50% 占比行
      .percent-row {
        display: flex;
        align-items: center;
        gap: 78px;
        margin-bottom: 40px;

        .percent-item {
          position: relative;
          text-align: center;
          color: #D93379;

          .number {
            font-size: 68px;
            font-weight: bold;
            margin-bottom: 8px;
            height: 44px;
            line-height: 80px;
            position: relative;
            background-color: rgba(#D93379, 0.1);
            display: flex;
            align-items: flex-end;
            justify-content: center;
          }

          .text {
            font-size: 20px;
            font-weight: 500;
            position: relative;
            z-index: 2;
          }
        }

        // 加号图标样式
        .percent-icon {
          color: #D93379;
          font-size: 40px;
          align-self: flex-start;
        }
      }

      // 科目卡片样式
      .subject-item {
        height: 100%;
        display: flex;
        flex-direction: column;

        .subject-name {
          background-color: #D93379;
          color: #fff;
          font-size: 20px;
          font-weight: 600;
          padding: 16px 24px;
          line-height: 28px;
          text-align: center;
        }

        .subject-remark {
          flex: 1;
          background: #EFEFEF;
          color: #333;
          font-size: 20px;
          padding: 24px 24px;
          line-height: 28px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .data-box {
      flex: 1;
      border-radius: 10px;
      border: 2px solid #D93379;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding: 24px;

      .data-item {
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }

      .data-icon {
        font-size: 22px;
        color: #D93379;
      }
    }
  }
}
</style>
